import { tsv } from "@faire/slate/lib/tsv";
import { isNotUndefined } from "@faire/typescript";
import React from "react";

import { ButtonLoading } from "./ButtonLoading";
import { INativeProps, IButtonClickHandler } from "./types";

type IProps = {
  as?: React.ElementType;
  loading?: boolean;
  loadingLabel?: string;
  onClick?: IButtonClickHandler;
  disabled?: boolean;
  ref?: React.Ref<unknown>;
  touchTargetSizePx?: string;
} & INativeProps;

export const ButtonBase = ({
  children,
  className,
  as: Component = "button",
  loading,
  loadingLabel,
  onClick,
  touchTargetSizePx,
  ...props
}: IProps) => {
  const buttonCls = baseButtonStyle.cls({ className, loading });

  return (
    <Component
      className={buttonCls}
      aria-disabled={loading || props.disabled}
      aria-busy={loading}
      aria-live={isNotUndefined(loading) ? "polite" : undefined}
      onClick={loading ? undefined : onClick}
      {...props}
    >
      {touchTargetSizePx ? (
        <div
          style={{ width: touchTargetSizePx, height: touchTargetSizePx }}
          className="absolute"
        />
      ) : null}
      {loading ? (
        <>
          <span className="invisible contents" aria-hidden="true">
            {children}
          </span>
          <ButtonLoading label={loadingLabel} />
        </>
      ) : (
        children
      )}
    </Component>
  );
};

const baseButtonStyle = tsv({
  base: "interactive focusable",
  variants: {
    loading: {
      true: "cursor-wait",
    },
  },
});
